import { useEffect } from "react";
import { useLocation } from "@remix-run/react";

// we'r using this hook to track the subpage also with matomo
// becuase the basic implementation would just track the main page.

export function useMatomo(
  gtaConsent: "all" | "necessary" | undefined,
  isProduction: boolean
) {
  const location = useLocation();

  useEffect(() => {
    //@ts-ignore
    if (gtaConsent === "all" && isProduction) {
      // Inject script once
      //@ts-ignore
      if (!window._matomoInitialized) {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://statistik.ru-digital.de/matomo.js";

        const trackerScript = document.createElement("script");
        trackerScript.innerHTML = `
          var _paq = window._paq = window._paq || [];
          _paq.push(['enableLinkTracking']);
          (function() {
            var u="https://statistik.ru-digital.de/";
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', '3']);
          })();
        `;

        document.head.appendChild(script);
        document.head.appendChild(trackerScript);
        //@ts-ignore
        window._matomoInitialized = true;
      }
    }
  }, [gtaConsent, isProduction]);

  //Trigger tracking on every route change
  useEffect(() => {
    //@ts-ignore
    if (gtaConsent === "all" && window._paq) {
      //@ts-ignore
      window._paq.push(["setCustomUrl", window.location.href]);
      //@ts-ignore
      window._paq.push(["setDocumentTitle", document.title]);
      //@ts-ignore
      window._paq.push(["trackPageView"]);
    }
  }, [location, gtaConsent]);
}
